<template>

	<v-content class="white">
		<lingo_program_branding></lingo_program_branding>

		<main_section></main_section>

		<!-- program branding container for mobile-->
		<section class="white relative nooverflow hidden-md-and-up pb-4" id="programBrandingMobile">
			<div style="height: 100px;width: 100%;background: linear-gradient(9deg, rgb(31, 189, 113), rgba(191, 255, 234, 0.95));position: absolute;top: -54px;transform: rotate(181deg);"></div>

			<v-layout row class="mt-4 pa-2 relative" align-center style="box-shadow: -1px 6px 6px -2px rgba(169, 169, 169, 0.35)">
				<v-flex xs6>
					<v-layout column class="mt-4 pr-3" align-end>
					<img src="../../..//assets/programLogo.png" width="134px" height="115px"/>
					</v-layout>
				</v-flex>
				<v-flex xs6>
					<v-layout column class="mt-4 pl-3" align-start>
					<img src="../../../assets/euSmall.png" width="134px" height="140px"/>
					</v-layout>
				</v-flex>
			</v-layout>
		</section>



		<features_section></features_section>
		<how_it_works_section></how_it_works_section>
		<try_it_section></try_it_section>
		<pricing_section></pricing_section>
		<contacts_section></contacts_section>


		<!-- Cookie Policy Alert -->
		<footer>
			<cookie-law theme="dark-lime" buttonText="OK, good to know"
				position="bottom" transitionName="fade">
				<div slot="message">
					We use a minimal set of cookies that our site requires in order to
					function correctly. Check out our
					<router-link to="/cookiePolicy"  class="info--text">Cookie Policy</router-link>
				</div>
			</cookie-law>
		</footer>

	</v-content>
</template>

<style>

@media (max-width: 1380px) {
	#programBrandingMobile {
		display:block !important;
	}
}

#programBrandingMobile {
		display:none;
	}

	.round-button {
	border-radius:30px;
	}


    .relative {
      position:relative;
    }

    .nooverflow {
      overflow:hidden;
    }

	.elevation-0 {
	box-shadow: none !important;
	}

</style>

<script>
	import {Auth} from '../auth/cognito_auth';
	import CookieLaw from 'vue-cookie-law';
	//import lingo_footer_light from '../FooterLight';
	import lingo_program_branding from '../ProgramBranding';
	import main_section from './MainSection';
	import features_section from './FeaturesSection';
	import how_it_works_section from './HowItWorksSection';
	import try_it_section from './TryItSection';
	import pricing_section from './PricingSection';
	import contacts_section from './ContactsSection';

	export default {
		name: 'WelcomePage',
		data () {
			return {
				e1: 0,
				file: 'https://ia802508.us.archive.org/5/items/testmp3testfile/mpthreetest.mp3'
			}
		},

		components: {
			CookieLaw,
			//lingo_footer_light,
			lingo_program_branding,
			main_section,
			features_section,
			how_it_works_section,
			try_it_section,
			pricing_section,
			contacts_section
		},

	created () {
		if (Auth.isUserLoggedIn()) {
			this.$router.replace({path: '/app'});
		}
	}
}
</script>
